export const SIGN_UP_SECTION_NAME: Readonly<string> = 'sign-up';
export const USER_TYPE_SCREEN_ID: Readonly<string> = 'sign-up-select-user-type';
export const EMAIL_INPUT_SCREEN_ID: Readonly<string> = 'sign-up-enter-email';
export const EMAIL_VERIFY_SCREEN_ID: Readonly<string> = 'sign-up-verify-email';
export const HOW_DID_YOU_HEAR_ABOUT_US_SCREEN_ID: Readonly<string> =
  'how-did-you-hear-about-us';
